<template>
  <div>
    <v-list-item class="py-3">
      <v-list-item-icon>
        <v-img
          class="width-100"
          src="..\static\img\favicon-lnf.png"
          max-width="25px"
        ></v-img>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title><h3>SRS Web App</h3></v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <!-- Admin navbar -->
    <v-list>
      <div v-for="(item, index) of routeItems" :key="index">
        <v-list-item @click="onRouteItem(item)">
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <div v-if="item.showChildren" v-bind:class="{ 'ml-3': !collapsed }">
          <v-list-item
            v-for="child in item.children"
            :key="child.text"
            sub-group
            @click="onRouteItem(child)"
          >
            <v-list-item-icon>
              <v-icon>{{ child.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ child.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>
      </div>
    </v-list>
    <!-- Admin navbar -->
  </div>
</template>

<script>
export default {
  props: {
    routeItems: {
      type: Array,
      required: false,
      default: () => [],
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: true,
    },
  }, // props

  methods: {
    onRouteItem($event) {
      $event.showChildren = !$event.showChildren;

      if ($event.path != null && $event.path.length > 0)
        this.$router.push({ path: $event.path });
    },
  }, // methods
};
</script>

<style>
</style>